<template>
  <v-alert
    border="left"
    colored-border
    color="green accent-4"
    elevation="2"
    :dismissible="true"
    type="success"
    :value="isShow"
  >
    All {{ SuccessCount }} payments have be processed successfully.
  </v-alert>
</template>

<script>
export default {
  props: {
    SuccessCount: {
      type: Number,
      default: 0,
      required: true
    },
    isShow: {
      type: Boolean,
      default: false,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.v-alert {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}
</style>
